<template>
  <LoadingWrapper :state="loadingState">
    <FullScreenLayoutContent :full-width="true">
      <template #header>
        <div class="flex h-16 items-center justify-between px-3 md:h-20 md:px-4">
          <BackButton backup-route-name="dashboard" icon="close" :title="$t('common.close')" />
          <div class="flex flex-row items-center">
            <SelfFeedbackAvatarFlow v-if="isSelfFeedback" :member="data.receiver" />
            <FeedbackAvatar v-else :member="data.receiver" type="to" />
            <span class="text-title-medium ml-2">
              <span v-if="isSelfFeedback">{{ $t('common.selfFeedback') }}</span>
              <span v-else> {{ $t('common.to') }}: {{ memberShortName(data.receiver) }} </span>
            </span>
          </div>
        </div>
      </template>
      <div class="w-full">
        <FinishFeedbackScreen
          v-if="state === 'finished'"
          :question-groups="data.questionGroups"
          :receiver="data.receiver"
          :is-superpower="data.isSuperpower"
          :shared-feedback="data.sharedFeedback"
          :supervisors="data.supervisors"
        />
        <template v-else>
          <SingleQuestionsView :question-groups="data.questionGroups" />
        </template>
      </div>
    </FullScreenLayoutContent>
  </LoadingWrapper>
</template>

<script setup lang="ts">
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { useRoute } from 'vue-router'
  import BackButton from '@/core/components/BackButton.vue'
  import { computed, ref } from 'vue'
  import SingleQuestionsView from '../components/single-questions-view/SingleQuestionsView.vue'
  import FullScreenLayoutContent from '@/core/components/layouts/FullScreenLayoutContent.vue'
  import { useGiveStructuredFeedback } from '../composables/useGiveStructuredFeedback'
  import FinishFeedbackScreen from '../components/finish-screen/FinishFeedbackScreen.vue'
  import FeedbackAvatar from '../../../core/components/feedback-avatar/FeedbackAvatar.vue'
  import SelfFeedbackAvatarFlow from '@/core/components/feedback-flow/SelfFeedbackAvatarFlow.vue'
  import { memberShortName } from '@/core/models/member/member-name.ts'

  const route = useRoute()

  const surveyId = ref(route.params.surveyId as string)
  const receiverId = ref(route.params.receiverId as string)

  const { data, loadingState, state } = useGiveStructuredFeedback(surveyId.value, receiverId.value)

  const isSelfFeedback = computed(() => data.value.receiver.id == data.value.sender.id)
</script>
